import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6506886a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view" }
const _hoisted_2 = { class: "token" }

import {onMounted, ref} from 'vue';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {ScForm} from "@/models/ScForm";
import ClipboardJS from "clipboard";
import {message} from "ant-design-vue";
import ScBtn from "@/components/common/widget/ScBtn.vue";
import {TokenFieldType} from "@/components/business/crud/interface/FieldType";
import _ from "lodash";

const characters = '123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenForm',
  props: {
    propName: {},
    widget: {},
    info: {}
  },
  setup(__props: any) {

const props = __props;

const data = ScForm.useFormData();
const btnRef = ref<InstanceType<typeof ScBtn>>();

onMounted(() => {
  if (btnRef.value) {
    new ClipboardJS(btnRef.value.$el);
  }
})

// 可以根据需要定义字符集合
async function regenerate() {
  data.value[props.propName] = _.sampleSize(characters, 26).join('')
}

function onCopy() {
  message.success('已复制');
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(data)[_ctx.propName] || ''), 1),
    _withDirectives(_createVNode(ScBtn, {
      confirm: _unref(data)[_ctx.propName] ? '确定要重新生成吗？' : undefined,
      handler: regenerate,
      style: {"margin-right":"8px"},
      size: "small",
      text: _unref(data)[_ctx.propName] ? '重新生成' : '生成'
    }, null, 8, ["confirm", "text"]), [
      [_vShow, _ctx.info.status === 'edit']
    ]),
    _withDirectives(_createVNode(ScBtn, {
      ref: "btn",
      "data-clipboard-text": _unref(data)[_ctx.propName] || '',
      handler: onCopy,
      size: "small",
      text: "复制",
      type: "primary"
    }, null, 8, ["data-clipboard-text"]), [
      [_vShow, _unref(data)[_ctx.propName]]
    ])
  ]))
}
}

})